export default __webpack_public_path__ + "locales/pl/DeleteProfileEverDialog.json?hash=d1447248ba9ae86ca763dc18c12f0845";